// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kGwJj{background:#452aec;border:none;border-radius:8px;cursor:pointer;height:41px;height:4.1rem;position:relative;width:41px;width:4.1rem}.kGwJj:hover{background:#351bd6}.kGwJj:after,.kGwJj:before{background:#fff;border-radius:8px;content:\"\";height:21px;height:2.1rem;left:20px;left:2rem;position:absolute;top:11px;top:1.1rem;width:1px}.kGwJj:after{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}", ""]);
// Exports
exports.locals = {
	"createButton": "kGwJj"
};
module.exports = exports;
